import { Input } from '@web/components/atoms/Input'
import { useDonationFormContext } from '@web/components/page-components/DonationForm'
import { useState } from 'react'
import RadioPanel from './RadioPanel'
import { useBrandingsStore } from '@web/components/utils/branding/useBrandingsStore'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { Field } from '@web/components/atoms/Field'

enum DonorType {
  Individual = 'Individual',
  Organisation = 'Organisation',
}

const NameForm = () => {
  const extraFields = useDonationFormContext((state) => state.formValues.extraFields ?? {})
  const { firstName, lastName, organisation } = extraFields
  const styles = useDonationFormContext((state) => state.settings.styles)
  const isOrganisationFieldIncluded =
    styles?.options?.isOrganisationFieldIncluded === undefined ? true : styles?.options?.isOrganisationFieldIncluded
  const actions = useDonationFormContext((state) => state.actions)
  const primaryColorFromBranding = useBrandingsStore(({ colorData }) => colorData['Brand'])
  const selectedHandleColor = useColorWithOpacity(
    styles?.selectedHandleColor,
    styles?.selectedHandleColorOpacity,
    styles?.accentColor ?? primaryColorFromBranding,
  )
  const unselectedHandleColor = useColorWithOpacity(
    styles?.unselectedHandleColor,
    styles?.unselectedHandleColorOpacity,
    '#FFFFFF',
  )
  const selectedTextColor = useColorWithOpacity(
    styles?.selectedHandleTextColor,
    styles?.selectedHandleTextColorOpacity,
    '#FFFFFF',
  )
  const unselectedTextColor = useColorWithOpacity(
    styles?.unselectedHandleTextColor,
    styles?.unselectedHandleTextColorOpacity,
    '#000000',
  )

  const [selectedDonorType, setSelectedDonorType] = useState(DonorType.Individual)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    actions.setFormValues({ extraFields: { ...extraFields, [e.currentTarget.name]: e.currentTarget.value } })
  }

  return (
    <>
      {isOrganisationFieldIncluded && (
        <>
          <RadioPanel
            selectedOption={selectedDonorType}
            isAttached={true}
            onChange={(option: string) => setSelectedDonorType(option as DonorType)}
            options={[DonorType.Individual, DonorType.Organisation]}
            styles={{
              selectedColor: selectedHandleColor,
              unselectedColor: unselectedHandleColor,
              selectedTextColor: selectedTextColor,
              unselectedTextColor: unselectedTextColor,
            }}
          />
          {selectedDonorType === DonorType.Organisation && (
            <Field label="Organisation Name" required={true}>
              <Input
                id="organisation-name"
                name="organisation"
                placeholder="Enter name"
                required={true}
                value={organisation}
                onChange={handleChange}
              />
            </Field>
          )}
        </>
      )}
      <Field label="First Name" required={true}>
        <Input
          id="first-name"
          placeholder="Enter name"
          name="firstName"
          required={true}
          value={firstName}
          onChange={handleChange}
        />
      </Field>
      <Field label="Last Name" required={true}>
        <Input
          id="last-name"
          name="lastName"
          placeholder="Enter name"
          required={true}
          value={lastName}
          onChange={handleChange}
        />
      </Field>
    </>
  )
}

export default NameForm
